import styled from 'styled-components';
import { Input, MultiSelectChips, Thumbnail, token } from '@bynder/design-system';

export const LoadingWrapper = styled.div`
    text-align: center;
`;

export const WarningWrapper = styled(Thumbnail.Indicator)`
    width: 16px;
    height: 16px;
    right: -4px;
    bottom: -4px;
`;

export const StyledMultiSelectChips = styled(MultiSelectChips)<{ disabled: boolean }>`
    & > div[class*='Container'] {
        ${({ disabled }) =>
            disabled &&
            `
        border-color: ${token.red500};
        `}
    }

    & > div[class*='Container'] > div > div[class*='IconRightContainer'] {
        display: none;
    }
`;

export const HiddenInput = styled(Input)`
    height: 0;
    border: 0;
    outline: none;
    box-shadow: none;

    &:focus,
    &:focus-visible,
    > input:focus,
    > input:focus-visible {
        outline: none;
        box-shadow: none;
    }

    > div {
        display: none;
    }
`;
